import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Social.css'
import socialHero from "../../../assets/images/Social Media Design.png";
import socialPosts from "../../../assets/images/Social Media Design.png";

const SocialDesign = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Social Media Graphics – BuddyTech Solutions </title>
        <meta name="description" content="Engaging social media visuals optimized for platforms like Facebook, Instagram, Twitter." />
        <meta name="keywords" content="social media graphics, digital design" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Social Media Graphics – BuddyTech Solutions" />
        <meta property="og:description" content="Engaging social media visuals optimized for platforms like Facebook, Instagram, Twitter." />
        <meta property="og:keywords" content="social media graphics, digital design" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/graphics/social" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Social Media Graphics – BuddyTech Solutions" />
        <meta name="twitter:description" content="Engaging social media visuals optimized for platforms like Facebook, Instagram, Twitter." />
        <meta name="twitter:keywords" content="social media graphics, digital design" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="social-container">
        <header className="social-hero">
          <div className="social-hero-content">
            <h1>Social Media Design</h1>
            <p>
              We design engaging social media creatives that drive interaction, reflect your brand, and increase visibility across all platforms.
            </p>
          </div>
          <img src={socialHero} alt="Social Media Hero" className="social-hero-img" />
        </header>

        <section className="social-section">
          <div className="social-text">
            <h2>What We Create</h2>
            <p>
              From daily posts to ad campaigns, our creatives are tailored to each platform and audience. We help brands grow their online presence through consistent and strategic visuals.
            </p>
            <ul>
              <li>Instagram & Facebook Posts</li>
              <li>Story Templates & Highlights</li>
              <li>LinkedIn Banners & Articles</li>
              <li>Reel Covers & Thumbnails</li>
              <li>Ad Creatives & Promotional Graphics</li>
            </ul>
          </div>
          <img src={socialPosts} alt="Social Media Posts" className="social-img" />
        </section>

        <section className="social-tools">
          <h2>Design Tools We Use</h2>
          <div className="tools-grid">
            <span>Adobe Photoshop</span>
            <span>Adobe Illustrator</span>
            <span>Canva</span>
            <span>Figma</span>
            <span>Crello</span>
            <span>Adobe Express</span>
          </div>
        </section>

        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919842084312">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default SocialDesign;